/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const separator = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="M4.5 12.5v4H3V7h1.5v3.987h15V7H21v9.5h-1.5v-4h-15Z" />
	</SVG>
);

export default separator;
